import Slider from "react-slick";
import { motion } from "framer-motion";
import { FiChevronDown } from "react-icons/fi";

import offer1 from "../../../assets/offers/offer1st.jpeg";
import offer2 from "../../../assets/offers/offer2nd.jpeg";
import offer3 from "../../../assets/offers/offer3rd.jpeg";
import offer4 from "../../../assets/offers/offer4th.jpeg";
import offer5 from "../../../assets/offers/offer5th.jpeg";
import offer6 from "../../../assets/offers/offer6th.jpeg";
import offer7 from "../../../assets/offers/offer7th.jpeg";
import pkoffer1 from "../../../assets/offers/pkoffer1.jpeg";
import pkoffer2 from "../../../assets/offers/pkoffer1.jpeg";

import offerBanner from "../../../assets/banners/websitebanner.webp";
import offervideo from "../../../assets/banners/video.mp4";

const offers = [
  {
    id: 8,
    title: "Grace. Beauty. Transformation — Just Like the Peacock.",
    desc: "Reveal your most radiant self with our exclusive Peacock Offer, designed for those who desire premium aesthetic care. Enjoy special rates.",
    image: pkoffer1,
  },
  // {
  //   id: 9,
  //   title: "Kabayan Beauty Treat",
  //   desc: "Experience a luxurious makeover designed exclusively for our Kabayan clients — because you deserve to feel radiant and confident every day.",
  //   image: pkoffer2,
  // },
  {
    id: 1,
    title: "Kabayan Beauty Treat",
    desc: "Experience a luxurious makeover designed exclusively for our Kabayan clients — because you deserve to feel radiant and confident every day.",
    image: offer1,
  },
  {
    id: 2,
    title: "Mommy Make Over",
    desc: "Reclaim your glow, moms! This makeover includes skin rejuvenation, shaping, and relaxation — because you deserve it.",
    image: offer2,
  },
  {
    id: 3,
    title: "Laser Hair Removal",
    desc: "Say goodbye to unwanted hair with our painless laser sessions. Smooth skin, long-lasting results — now at a special rate!",
    image: offer3,
  },
  {
    id: 4,
    title: "Pink Lips Treatment",
    desc: "Get naturally soft, pink lips with our gentle lightening and hydration therapy — safe, effective, and now on offer!",
    image: offer4,
  },
  {
    id: 5,
    title: "Weightloss Treatments",
    desc: "Jumpstart your fitness journey with our targeted weight loss sessions. Scientifically backed and now at a discounted price!",
    image: offer5,
  },
  {
    id: 6,
    title: "Slimming Treatments",
    desc: "Shape up fast with our non-invasive slimming packages. Contour your body with visible results — limited-time offer!",
    image: offer6,
  },
  {
    id: 7,
    title: "Barbei Arms HIFU",
    desc: "Tone and tighten your arms with advanced HIFU technology. No downtime, just stunning results — grab the offer now!",
    image: offer7,
  },
];

const SpecialOffersPage = () => {
  const sliderSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
  };

  const arrowAnimation = {
    y: [0, 15, 0],
    transition: { duration: 1.5, repeat: Infinity, ease: "easeInOut" },
  };

  return (
    <div className="special-offers-page">
      <div className="position-relative overflow-hidden w-100">
        {/* <img
          src={offerBanner}
          alt="Special"
          className="img-fluid d-block w-100 mx-auto container mt-1 "
          style={{
            // objectFit: "cover",
            // maxHeight: "720px",
            height: "auto",
          }}
        /> */}

        <div
          className="position-absolute start-50 translate-middle-x"
          style={{ bottom: "30px", zIndex: 2 }}
        >
          <motion.div
            animate={arrowAnimation}
            style={{ fontSize: 40, color: "#c69933" }}
          >
            <FiChevronDown />
          </motion.div>
        </div>
      </div>

      {/* Offers Section */}
      <section className="py-5">
        <div className="container">
          <div className="text-center mb-5">
            <motion.h2
              className="display-5 fw-bold mb-3"
              initial={{ opacity: 0, y: -30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              Special Offers
            </motion.h2>
            <motion.p
              className="text-muted fs-5"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              Book your look at the best rates
            </motion.p>
          </div>

          <div className="row g-4">
            {offers.map((offer, index) => (
              <motion.div
                key={offer.id}
                className="col-12 col-md-4"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
              >
                <motion.div
                  whileHover={{ scale: 1.02 }}
                  transition={{ type: "spring", stiffness: 300 }}
                  className="card border-0 shadow-lg"
                >
                  <div className="">
                    <motion.img
                      src={offer.image}
                      alt={offer.title}
                      className="img-fluid w-100"
                      style={{
                        objectFit: "cover",
                        height: "100%",
                        maxWidth: "500px",
                        transition: "transform 0.6s ease",
                      }}
                      whileHover={{ scale: 1.01 }}
                    />
                  </div>

                  <div className="card-body px-4 py-3 d-flex flex-column">
                    <motion.h5
                      className="fw-bold mb-2"
                      initial={{ opacity: 0, x: -30 }}
                      whileInView={{ opacity: 1, x: 0 }}
                      transition={{ duration: 0.5 }}
                      style={{
                        color: "#c69933",
                      }}
                    >
                      {offer.title}
                    </motion.h5>

                    <motion.p
                      className="text-secondary flex-grow-1"
                      initial={{ opacity: 0, x: 30 }}
                      whileInView={{ opacity: 1, x: 0 }}
                      transition={{ duration: 0.5, delay: 0.1 }}
                    >
                      {offer.desc}
                    </motion.p>
                  </div>
                </motion.div>
              </motion.div>
            ))}
          </div>
        </div>

        {/* CSS Animations & Style Enhancements */}
        <style jsx>{`
          .card {
            transition: transform 0.3s ease, box-shadow 0.3s ease;
          }

          .card:hover {
            box-shadow: 0 12px 30px rgba(0, 0, 0, 0.1);
          }

          .glass-card {
            backdrop-filter: blur(10px);
            background: rgba(255, 255, 255, 0.85);
            border: 1px solid rgba(255, 255, 255, 0.3);
          }

          .btn:hover {
            opacity: 0.9;
          }
        `}</style>
      </section>
    </div>
  );
};

export default SpecialOffersPage;
